/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IIntegrationEndpoint } from 'app/shared/model/integration-endpoint.model';
import { ITenantIntegrationEndpointAttribute } from 'app/shared/model/tenant-integration-endpoint-attribute.model';

export interface IIntegrationEndpointAttribute {
  id?: string;
  name?: string | null;
  defaultValue?: string | null;
  example?: string | null;
  mandatory?: boolean | null;
  userSpecific?: boolean | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  coFormat?: IClinicalDictionary | null;
  ciFormat?: IClinicalDictionary | null;
  attributeType?: IClinicalDictionary | null;
  valueType?: IClinicalDictionary | null;
  valueRange?: IClinicalDictionary | null;
  endpoint?: IIntegrationEndpoint | null;
  parent?: IIntegrationEndpointAttribute | null;
  tenantAttribute?: ITenantIntegrationEndpointAttribute | null;
}

export const defaultValue: Readonly<IIntegrationEndpointAttribute> = {
  mandatory: false,
  userSpecific: false,
  active: false,
};
